import * as React from "react";

function SvgComponent(props) {
  return <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16.009" width="1em" height="1em" {...props}><g color="#000" fill="#474747"><path d="M7.062.01c-.454.049-.883.22-1.25.5C5.324.88 5 1.463 5 2.196v5.312s.236.507.5.507.5-.507.5-.507V2.197c0-.45.172-.704.437-.907.266-.202.664-.3 1.063-.28.399.018.784.153 1.062.405.279.253.47.585.47 1.125 0 2.166 1.463 3.51 3 3.47.856-.023 1.687-.478 2.25-1.313l-.563-1c-.376.915-1.068 1.295-1.719 1.312-.96.025-1.969-.73-1.969-2.469 0-.792-.337-1.443-.812-1.875C8.743.235 8.138.038 7.53.01c-.151-.007-.317-.016-.469 0zm6.938 2v.124l.781 1.375c.012-.04.021-.083.031-.125zm0 .343c-.006.106-.02.214-.031.312l.719 1.22c.023-.063.041-.123.062-.188zm-.063.5c-.013.09-.044.166-.062.25l.656 1.125c.03-.061.067-.124.094-.188zm-.093.437c-.024.09-.066.17-.094.25l.594 1.032c.04-.065.088-.119.125-.188z" style={{
        lineHeight: "normal",
        InkscapeFontSpecification: "Sans",
        textIndent: 0,
        textAlign: "start",
        textDecorationLine: "none",
        textTransform: "none",
        marker: "none"
      }} fontWeight={400} fontFamily="Sans" overflow="visible" /><path d="M2.727 6.01h5.546c.403 0 .727.323.727.726v6.546a.725.725 0 01-.727.727H2.727A.725.725 0 012 13.282V6.736c0-.403.324-.727.727-.727z" style={{
        marker: "none"
      }} overflow="visible" /></g></svg>;
}

export default SvgComponent;